export const serviceFilterArabic = {
  'Advance Filter': 'فلتر متقدم', 'Close filters': 'إغلاق الفلاتر',
  'Select filters, then apply them to the service list.': 'اختر الفلاتر ثم طبّقها على قائمة الخدمات.',
  'Platforms': 'المنصات', 'Services': 'الخدمات', 'Price Range': 'نطاق السعر',
  'Sort by Price': 'الترتيب حسب السعر', 'Low to High': 'من الأقل للأعلى', 'High to Low': 'من الأعلى للأقل',
  'Apply': 'تطبيق', 'Remove filters': 'مسح الفلاتر', 'All': 'الكل', 'Favorite services': 'الخدمات المفضلة',
  'Minimum price / 1000 (USD)': 'أقل سعر لكل 1000 (دولار)', 'Maximum price / 1000 (USD)': 'أعلى سعر لكل 1000 (دولار)',
  'Min': 'الأدنى', 'Max': 'الأعلى', 'Enter a valid non-negative price.': 'أدخل سعرًا صحيحًا لا يقل عن صفر.',
  'Minimum price must not exceed maximum price.': 'يجب ألا يتجاوز السعر الأدنى السعر الأعلى.',
  'Comments': 'التعليقات', 'Favorites': 'التفضيلات', 'Followers': 'المتابعون', 'Impressions': 'مرات الظهور',
  'Likes': 'الإعجابات', 'Members': 'الأعضاء', 'Mentions': 'الإشارات', 'Plays': 'التشغيلات', 'Posts': 'المنشورات',
  'Reach': 'الوصول', 'Reactions': 'التفاعلات', 'Reposts': 'إعادة النشر', 'Retweets': 'إعادة التغريد',
  'Saves': 'الحفظ', 'Shares': 'المشاركات', 'Streams': 'البث', 'Subscribers': 'المشتركون',
  'Views': 'المشاهدات', 'Votes': 'التصويتات', 'Watch time': 'وقت المشاهدة',
};
